import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './language/en.json'
import bn from './language/bn.json'
import gu from './language/gu.json'
import hi from './language/hi.json'
import kn from './language/kn.json'
import ml from './language/ml.json'
import mr from './language/mr.json'
import or from './language/or.json'
import pa from './language/pa.json'
import ta from './language/ta.json'
import te from './language/te.json'
export const defaultNS = 'ns1'

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: process.env.REACT_APP_ENV === 'local',
		keySeparator: false,
		interpolation: {
			escapeValue: false,
		},
		lng: 'en',
		fallbackLng: 'en',
		defaultNS,
		resources: {
			en: {
				ns1: en,
			},
			bn: {
				ns1: bn,
			},
			gu: {
				ns1: gu,
			},
			hi: {
				ns1: hi,
			},
			kn: {
				ns1: kn,
			},
			ml: {
				ns1: ml,
			},
			mr: {
				ns1: mr,
			},
			or: {
				ns1: or,
			},
			pa: {
				ns1: pa,
			},
			ta: {
				ns1: ta,
			},
			te: {
				ns1: te,
			},
		},
	})

export default i18n
